<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
       padding20
      :confirmLoading="confirmLoading"
      :contentStyle="{height: '100%'}"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>同步货件</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="90px"
          >
        <el-form-item
            label="店铺/国家"
            prop="marketId"
            :rules="[
              { required: true, message: '请选择店铺/国家', trigger: ['blur', 'change'] }
            ]">
          <gj-market-select
              v-model="form.marketId"
              :clearable="false"
              width="370px"
          ></gj-market-select>
        </el-form-item>
        <el-form-item
            label="ShipmentID"
            prop="shipmentId"
            :rules="[
              { required: true, message: '请输入ShipmentID', trigger: ['blur', 'change'] }
            ]">
          <gj-textarea
              v-model="form.shipmentId"
              placeholder="如果有多个，仅支持每行填写一个"
              :styles="{height: '200px', fontSize: '12px'}"
          ></gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formValidatorMixin, modalMixIn, responseMixin} from "../../../../../minxins";
  import {splitAndUnique} from "../../../../../utils/common";
  import {syncFbaShipment} from "../../../../../api/logistics";

  export default {
    name: "app-sync-fba-shipment-modal",
    mixins: [modalMixIn, formValidatorMixin, responseMixin],
    data() {
      return {
        confirmLoading: false,
        form: {
          marketId: null,
          shipmentId: null
        }
      }
    },
    methods: {
      confirm() {
        if (this.formValidate()) {
          this.confirmLoading = true;
          const shipmentIds = splitAndUnique(this.form.shipmentId);
          syncFbaShipment({
            marketId: this.form.marketId,
            shipmentIds,
          })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success(res.data || '同步成功');
                this.$emit('created');
                this.$gjDestroy();
              });
            })
            .complete(() => this.confirmLoading = false);

        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.el-dialog__body{
    padding: 16px 20px 0 20px;
  }
  /deep/ .el-form-item:last-child{
    margin-bottom: 0;
  }
</style>






















